import appStoreIcon from './appStoreIcon.svg';
import arrowDownCollapse from './arrowDownCollapse.svg';
import logoBBSeguros from './bbseguros.svg';
import logoBBSegurosAmarelo from './bbSegurosAmarelo.png';
import logobbseguroBranco from './bbsegurosBranco.svg';
import chat from './chat.svg';
import { ReactComponent as FaleComAGenteIcon } from './FaleComAGenteIcon.svg';
import { ReactComponent as IconErro } from './iconErro.svg';
import { ReactComponent as LogoAliancaDoBrasilHeader } from './logoAliancaDoBrasilHeader.svg';
import { ReactComponent as LogoBBSegurosHeader } from './logoBBSegurosHeader.svg';
import phoneIcon from './phoneIcon.svg';
import playStoreIcon from './playStoreIcon.svg';
import { ReactComponent as TiktokIcon } from './TiktokIcon.svg';
import whatsappFooter from './whatsappFooter.svg';

const images = {
  appStoreIcon,
  arrowDownCollapse,
  logobbseguroBranco,
  chat,
  phoneIcon,
  whatsappFooter,
  playStoreIcon,
  IconErro,
  logoBBSeguros,
  logoBBSegurosAmarelo,
  FaleComAGenteIcon,
  TiktokIcon,
  LogoBBSegurosHeader,
  LogoAliancaDoBrasilHeader,
};

export {
  arrowDownCollapse,
  appStoreIcon,
  playStoreIcon,
  IconErro,
  logoBBSeguros,
  TiktokIcon,
  LogoBBSegurosHeader,
  LogoAliancaDoBrasilHeader,
  logoBBSegurosAmarelo,
  FaleComAGenteIcon,
};

export default images;
